module.exports = __webpack_public_path__ + "img/ban_02.c7ed9fff.png";